import { createRoutine } from 'redux-saga-routines';

import { GET_AGENCIES_BY_COUNTRY, GET_AGENCIES_LIST } from './constants';

export const getAgenciesByCountryAction = createRoutine(GET_AGENCIES_BY_COUNTRY);
export const getAgenciesList = createRoutine(GET_AGENCIES_LIST);
